import React from 'react';
import { connectMenu } from 'react-instantsearch-core';
import { privateSaleShape } from 'shapes';

const VirtualMenu = connectMenu(() => null);

export default function PrivateSaleLocker({ sale }) {
    return (
        <VirtualMenu
            attribute="private_sale_ids"
            defaultRefinement={`${sale.id}`}
        />
    );
}

PrivateSaleLocker.propTypes = {
    sale: privateSaleShape.isRequired,
};
